import React from 'react';
import { education } from '../data';

function Education() {
  return (
    <section className="section" id="education">
      <div className="section-head reveal">
        <span className="eyebrow">
          <i className="fa-solid fa-graduation-cap"></i> Education
        </span>
        <h2 className="section-title">
          Learning <span className="gradient-text">journey</span>
        </h2>
      </div>

      <div className="edu-grid">
        {education.map((e) => (
          <div key={e.school} className="edu-card card reveal">
            <i className={e.icon}></i>
            <div>
              <h4>{e.school}</h4>
              <p>{e.detail}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Education;
